// @flow
import OrgsOrderTableRow from './OrgsOrderTableRow';

export default OrgsOrderTableRow;
